import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">
          {/* Logo and tagline */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_elementor-site-1/artifacts/ezkys4rp_df349819-de0d-4936-a5a7-6cc61c7e7cb0.png" 
              alt="WildCamping Logo" 
              className="h-32 w-auto object-contain"
              style={{ mixBlendMode: 'lighten' }}
            />
          </div>

          {/* Navigation links */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <Link to="/about" className="hover:text-orange-500 transition-colors">
              O projektu
            </Link>
            <Link to="/how-it-works" className="hover:text-orange-500 transition-colors">
              Jak to funguje
            </Link>
            <Link to="/contact" className="hover:text-orange-500 transition-colors">
              Kontakt
            </Link>
            <Link to="/terms" className="hover:text-orange-500 transition-colors" data-testid="footer-terms-link">
              Obchodní podmínky
            </Link>
          </div>

          {/* Social links */}
          <div className="flex items-center gap-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 p-3 rounded-lg hover:bg-orange-500 transition-all duration-300"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 p-3 rounded-lg hover:bg-orange-500 transition-all duration-300"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mb-6"></div>

        {/* Bottom section */}
        <div className="text-center text-sm text-gray-400">
          <p>© 2026 WildCamping s.r.o. Všechna práva vyhrazena.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
